import DetailLeg from "./detail";

const routes = [
  {
    path: "/leg/:id",
    component: DetailLeg,
  },
];

export default routes;
